import React from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import InfoIcon from "@mui/icons-material/Info";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { useTranslation } from "react-i18next";
const CountingConfirmation = ({
  CText,
  TotalOK,
  TotalNOK,
  terminal_id,
  storage_bin,
  storage_loc,
}) => {
  const navigate = useNavigate();
  const handleClose = () => {
    navigate(
      `/warehouse/whs-location-info?terminal_id=${terminal_id}&storage_bin=${storage_bin}&storage_loc=${storage_loc}`
    );
  };
  const { t } = useTranslation();
  const totalMaterials = TotalOK + TotalNOK;
  const okPercentage = ((TotalOK / totalMaterials) * 100).toFixed(2);
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.81)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
    >
      <div
        style={{
          position: "relative",
          backgroundColor: "#fff",
          borderRadius: "18px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
          width: "90%",
          maxWidth: "400px",
          textAlign: "center",
          overflowY: "auto",
          maxHeight: "90%",
        }}
      >
        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            background: "none",
            border: "none",
            cursor: "pointer",
          }}
        >
          <CloseIcon style={{ fontSize: "30px" }} />
        </button>
        <InfoIcon
          style={{
            fontSize: "40px",
            color: "#052660",
            margin: "35px 20px 0",
          }}
        />
        <p
          style={{
            fontSize: "18px",
            color: "#333",
            lineHeight: "25px",
            fontWeight: "300",
            padding: "10px",
          }}
        >
          {CText}{" "}
          <TaskAltIcon
            style={{
              color: "#6CBE29",
              fontSize: "22px",
              verticalAlign: "middle",
            }}
          />
        </p>

        <div
          style={{
            display: "table",
            margin: "10px auto",
            textAlign: "left",
            padding: "0 10px",
            width: "80%",
            maxWidth: "420px",
            fontWeight: "300",
          }}
        >
          <div style={{ display: "table-row" }}>
            <span style={{ display: "table-cell", padding: "10px 0" }}>
              {t("total_ok")}
            </span>
            <span style={{ display: "table-cell", padding: "0 5px" }}>: </span>
            <span style={{ display: "table-cell" }}>{TotalOK}</span>
          </div>
          <div style={{ display: "table-row" }}>
            <span style={{ display: "table-cell", padding: "10px 0" }}>
              {t("total_nok")}
            </span>
            <span style={{ display: "table-cell", padding: "0 5px" }}>: </span>
            <span style={{ display: "table-cell" }}>{TotalNOK}</span>
          </div>
          <div style={{ display: "table-row" }}>
            <span style={{ display: "table-cell", padding: "10px 0" }}>
              {t("percentage_ok")}
            </span>
            <span style={{ display: "table-cell", padding: "0 5px" }}>: </span>
            <span style={{ display: "table-cell" }}>{okPercentage}%</span>
          </div>
        </div>
        <button
          onClick={handleClose}
          style={{
            background: "none",
            border: "none",
            width: "100%",
            fontSize: "20px",
            cursor: "pointer",
            height: "50px",
            backgroundColor: "#052660",
            color: "#fff",
            borderRadius: "0 0 10px 10px",
            marginTop: "15px",
          }}
        >
          {t("close")}
        </button>
      </div>
    </div>
  );
};
export default CountingConfirmation;
